module.exports = __webpack_public_path__ + "img/poppericon.8062e656.png";